export default "<m-plane\n    y=\"5\"\n    width=\"10\"\n    rx=\"40\"\n    ry=\"25\"\n    rz=\"40\"\n    color=\"yellow\"\n></m-plane>\n";